import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=3b325906&scoped=true&"
import script from "./UserManage.vue?vue&type=script&lang=js&"
export * from "./UserManage.vue?vue&type=script&lang=js&"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=3b325906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b325906",
  null
  
)

export default component.exports